<div class="header" mat-dialog-title>
  <div class="hotlistDropdown" *ngIf="data.hotlists.length">
    <span>{{ 'vehicleIntelligence.hotlist.platesIn' | t }}</span>
    <mat-form-field appearance="fill">
      <mat-label>{{ 'common.hotlist' | t }}</mat-label>
      <mat-select (selectionChange)="onHotlistChange($event)" [(ngModel)]="activeHotlist">
        <mat-option *ngFor="let hotlist of data.hotlists" [value]="hotlist">
          {{ hotlist.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="actions" *ngIf="activeHotlist">
    <div class="lpr-columns-actions__expand" (click)="$event.stopPropagation()">
      <button mat-fab extended class="lpr-columns-actions__colbutton mat-fab mat-fab--extended">
        <span class="mat-fab__label">{{ 'common.columns' | t }}</span>
        <span class="material-icons mat-fab__icon">add_circle</span>
      </button>
      <div class="lpr-columns-actions__options" mat-elevation-z8>
        <mat-checkbox (change)="toggleAllColumns($event)">{{ 'common.selectAll' | t }}</mat-checkbox>
        <button mat-fab extended class="mat-fab mat-fab--extended" (click)="resetColumns()">
          {{ 'common.resetToDefault' | t }}
        </button>
        <mat-selection-list>
          <mat-list-option
            *ngFor="let column of columns; let i = index; trackBy: trackColumn"
            [selected]="!column.hideInList"
            (click)="toggleColumn(i)"
          >
            <ng-container *ngIf="column.name !== 'action'">
              {{ column.name }}
            </ng-container>
          </mat-list-option>
        </mat-selection-list>
      </div>
    </div>
    <button
      type="button"
      [mtBasicSpinner]="isLoading"
      [hideText]="true"
      mat-icon-button
      [matTooltip]="'vehicleIntelligence.hotlist.downloadPlates' | t"
      color="accent"
      (click)="downloadPlates(activeHotlist.id, activeHotlist.name)"
    >
      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-content>
  <sn-data-list #listElement reloadByQueryParams [fetchFn]="loadData">
    <sn-infinite-scroll windowScrollTarget>
      <sn-pull-to-refresh>
        <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="table"></ng-template>
        <ng-template
          [ngIf]="!list.dataSource.data.length && list.dataIsInited"
          [ngIfThen]="emptyList"
        ></ng-template>
      </sn-pull-to-refresh>
    </sn-infinite-scroll>
  </sn-data-list>
</div>
<ng-template #table>
  <form class="searchBar">
    <input [placeholder]="'common.search' | t" [formControl]="searchControl" />
    <sn-icon-button
      fontSet="fal"
      fontIcon="fa-magnifying-glass"
      mat-icon-button
      [matTooltip]="'common.search' | t"
      class="mat-searchbar__search-button"
    ></sn-icon-button>
    <sn-icon-button
      fontSet="fal"
      fontIcon="fa-xmark"
      mat-icon-button
      [matTooltip]="'common.clearSearch' | t"
      class="mat-searchbar__clear-button"
      (click)="clear()"
    ></sn-icon-button>
  </form>
  <fs-lpr-hotlists-plates-table
    [hotlist]="activeHotlist"
    [columns]="columnNames"
    [items]="list.dataSource.data"
    [sort]="sort"
    [sortDirection]="sortDirection"
    (sortChange)="onSortChange($event)"
    [actions]="actions"
  >
  </fs-lpr-hotlists-plates-table>
</ng-template>

<ng-template #emptyList>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t"> {{ 'common.noResultsFound' | t }} </sn-empty-state>
</ng-template>

<mat-dialog-actions>
  <button mat-button mat-dialog-close color="danger">{{ 'common.close' | t }}</button>
  <button mat-button color="success" (click)="addPlate()" *ngIf="canAddPlate">{{ 'common.addGroup' | t }}</button>
</mat-dialog-actions>
